import { hashGrouping } from "./util";

const updateConstraintSaveStatus = ({
  forecastModel,
  cellId,
  status,
  savedConstraint,
}) => {
  const {
    lookups: { constraintCellLookup },
  } = forecastModel;

  const constraintCell = constraintCellLookup[cellId];

  if (!constraintCell) {
    return forecastModel;
  }

  // Already saved
  if (constraintCell.constraintSaveStatus === status) {
    return forecastModel;
  }

  constraintCell.constraintSaveStatus = status;

  if (savedConstraint) {
    // Keep model constraint value in sync with mutation response.
    // DynamicConstraintFragment returns direct/hierarchy fields.
    const savedValue = constraintCell.isDirectConstraint
      ? savedConstraint.directConstraint
      : savedConstraint.hierarchyConstraint;
    if (savedValue !== undefined) {
      constraintCell.constraint = savedValue;
    }
  }

  hashGrouping(constraintCell.grouping, {
    rehashParents: true,
  });

  return forecastModel;
};

export default updateConstraintSaveStatus;
